export default "__VITE_ASSET__CGUCPtyx__"